import { Flex, Spin } from "antd"
import React from "react"




const Loading = () => {
  return (
    <Flex gap={'middle'} justify='center' align='center' className='w-full' style={{minHeight: '90vh'}}>
      <Spin tip='Loading' size='large'>
        <div style={{
              padding: 50,
              background: 'rgba(0, 0, 0, 0.05)',
              borderRadius: 4,
            }}>
        </div>
      </Spin>
    </Flex>
  )
};


export default Loading;